module.exports = __webpack_public_path__ + "img/changeFinish-1.906be04.png";